/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_MethodologyInputs */

const en_directory_agent_readiness_methodology = /** @type {(inputs: Directory_Agent_Readiness_MethodologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This audit evaluates documented operability from one entry URL and its verified official source chain. It does not claim that SEEKAI registered, signed in, purchased, executed, or reliability-tested the product.`)
};

const zh_directory_agent_readiness_methodology = /** @type {(inputs: Directory_Agent_Readiness_MethodologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本审计从一个入口 URL 及其经过验证的官方来源链评估文档所支持的可操作性。SEEKAI 未注册、登录、购买、执行或测试该产品的运行可靠性。`)
};

/**
* | output |
* | --- |
* | "This audit evaluates documented operability from one entry URL and its verified official source chain. It does not claim that SEEKAI registered, signed in, p..." |
*
* @param {Directory_Agent_Readiness_MethodologyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_methodology = /** @type {((inputs?: Directory_Agent_Readiness_MethodologyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_MethodologyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_methodology(inputs)
	return zh_directory_agent_readiness_methodology(inputs)
});
export { directory_agent_readiness_methodology as "directory.agent_readiness.methodology" }